var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / FM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-FM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#95CEF5",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,12.6666667 L14.6426452,14.4488081 L16.5361507,14.509288 L15.0398218,15.6711919 L15.5674273,17.490712 L14,16.4266667 L12.4325727,17.490712 L12.9601782,15.6711919 L11.4638493,14.509288 L13.3573548,14.4488081 L14,12.6666667 Z M19.3333333,7.33333333 L19.9759785,9.11547476 L21.869484,9.17595468 L20.3731551,10.3378586 L20.9007607,12.1573787 L19.3333333,11.0933333 L17.765906,12.1573787 L18.2935116,10.3378586 L16.7971826,9.17595468 L18.6906881,9.11547476 L19.3333333,7.33333333 Z M8.66666667,7.33333333 L9.30931187,9.11547476 L11.2028174,9.17595468 L9.70648845,10.3378586 L10.234094,12.1573787 L8.66666667,11.0933333 L7.09923933,12.1573787 L7.62684488,10.3378586 L6.13051596,9.17595468 L8.02402146,9.11547476 L8.66666667,7.33333333 Z M14,2 L14.6426452,3.78214143 L16.5361507,3.84262135 L15.0398218,5.00452524 L15.5674273,6.82404532 L14,5.75999999 L12.4325727,6.82404532 L12.9601782,5.00452524 L11.4638493,3.84262135 L13.3573548,3.78214143 L14,2 Z",
    id: "Star-33",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFm);
export default __webpack_public_path__ + "static/media/FM.604129561bcbfb8dee387d42d200941d.svg";
export { ForwardRef as ReactComponent };